import { useMutation, useQueryClient } from "@tanstack/react-query";
import {
  LanguageSkill,
  PersonLanguage,
} from "../../models/languageSkill.model";
import { LanguageSkillService } from "../../services/languageSkillService";

const languageSkillService = new LanguageSkillService();

export const useLanguageSkillMutations = () => {
  const queryClient = useQueryClient();

  // Invalidate language skills cache for a user
  const invalidateLanguageSkills = (userId: number) => {
    queryClient.invalidateQueries({
      queryKey: ["languageSkills", userId],
    });
  };

  // Add language skill mutation
  const addLanguageSkill = useMutation({
    mutationFn: (data: LanguageSkill): Promise<PersonLanguage> => {
      return languageSkillService.addData(data);
    },
    onSuccess: (_, variables) => {
      invalidateLanguageSkills(variables.userId);
    },
  });

  // Update language skill mutation
  const updateLanguageSkill = useMutation({
    mutationFn: (data: LanguageSkill): Promise<PersonLanguage> => {
      return languageSkillService.updateData(data);
    },
    onSuccess: (_, variables) => {
      invalidateLanguageSkills(variables.userId);
    },
  });

  // Delete language skill mutation
  const deleteLanguageSkill = useMutation({
    mutationFn: (data: LanguageSkill): Promise<void> => {
      return languageSkillService.deleteData(data);
    },
    onSuccess: (_, variables) => {
      invalidateLanguageSkills(variables.userId);
    },
  });

  return {
    addLanguageSkill,
    updateLanguageSkill,
    deleteLanguageSkill,
    invalidateLanguageSkills,
  };
};
